// extracted by mini-css-extract-plugin
export default {"block":"Notification_block__Sf0fc","image":"Notification_image__gp+P1"};